import * as types from './constants';

// Sendbird Token
export const setSendbirdUnreadMessages = data => (
  { type: types.SET_SENDBIRD_UNREAD_MESSAGES, payload: data }
);